import axios from 'axios';
import ServiciosEditar from '../types/ServiciosEditar';

async function InsertarServicio(ServicioNuevo: ServiciosEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_servicio";
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "servicio": {
                    "nombre": ServicioNuevo.nombre,
                    "descripcion": ServicioNuevo.descripcion,
                    "habilitado": ServicioNuevo.habilitado,
                    "dado_de_baja": ServicioNuevo.dado_de_baja,
                    "logo_mime": ServicioNuevo.logo_mime,
                    "logo_content": ServicioNuevo.logo_content,
                    "logo_name": ServicioNuevo.logo_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarServicio;